import { Tooltip } from '@mui/material'
import React from 'react'
import "./Heading.css"
import { TranslationEnum, usePortalTranslation } from '../../providers/TranslationProvider'
const BorderHeading = (props:{children:string,tooltip?:React.ReactElement}) => {
    const {children,tooltip}=props
    const { translate } = usePortalTranslation();
  return (
    tooltip?
    <Tooltip title={tooltip}>
    <div className="border_heading">
        {children}
    </div>
</Tooltip>
:
<div className="border_heading">
{translate(TranslationEnum.ui_config,children)}
</div>
  )
}

export default BorderHeading